module.exports = __webpack_public_path__ + "img/Storyteller.2e0c63e5.jpg";